/*
 * @Author: kian
 * @Date: 2021-11-23 09:10:14
 * @LastEditors: kian
 * @LastEditTime: 2021-11-23 09:42:39
 * @Description:
 */

export function UpDownColor(i) {
  return +i >= 0 ? (+i === 0 ? '#999999' : '#FF4040') : '#1EB955';
}

export function YAxisLabelPositionRich(i) {
  if (i === 0) {
    return '0%';
  }
}

// 小数转股票涨跌幅
export function ToPercent(num) {
  if (!num) return '-';
  const res = (num * 100).toFixed(2);
  if (res > 0) {
    return `+${res}%`;
  } else {
    return `${res}%`;
  }
}
